import React, { useState } from "react";
import "./PAMMCommissionReport.css";
import { Eye, Download, Calendar } from "lucide-react";

function PAMMCommissionReport() {
  const [reports] = useState([
    { id: 1, period: "November 2025", totalCommission: "$12,500", paidCommission: "$10,000", pendingCommission: "$2,500", totalTrades: 1250, totalVolume: "$5,200,000", status: "Partial" },
    { id: 2, period: "October 2025", totalCommission: "$15,800", paidCommission: "$15,800", pendingCommission: "$0", totalTrades: 1580, totalVolume: "$6,500,000", status: "Paid" },
    { id: 3, period: "September 2025", totalCommission: "$11,200", paidCommission: "$11,200", pendingCommission: "$0", totalTrades: 1120, totalVolume: "$4,800,000", status: "Paid" },
  ]);

  return (
    <div className="pamm-commission-container">
      {/* Page Header */}
      <div className="page-header">
        <div className="header-left">
          <h1>PAMM Commission Report</h1>
          <div className="header-bottom">
            <h2 className="view-all">View commission reports by period</h2>
          </div>
        </div>
        <div className="header-right">
          <button className="btn">
            <Calendar size={16} /> Generate Report
          </button>
          <button className="btn orange">Export All</button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="stats-row">
        <div className="stat-card">
          <h3>Total Commission (YTD)</h3>
          <p className="stat-value">$125,500</p>
        </div>
        <div className="stat-card">
          <h3>Paid Commission (YTD)</h3>
          <p className="stat-value success">$118,000</p>
        </div>
        <div className="stat-card">
          <h3>Pending Commission</h3>
          <p className="stat-value warning">$7,500</p>
        </div>
        <div className="stat-card">
          <h3>Total Trading Volume (YTD)</h3>
          <p className="stat-value">$52,000,000</p>
        </div>
      </div>

      {/* Filters Section */}
      <div className="filters">
        <select>
          <option>Select Year</option>
          <option>2025</option>
          <option>2024</option>
          <option>2023</option>
        </select>
        <select>
          <option>Select Month</option>
          <option>January</option>
          <option>February</option>
          <option>March</option>
          <option>April</option>
          <option>May</option>
          <option>June</option>
          <option>July</option>
          <option>August</option>
          <option>September</option>
          <option>October</option>
          <option>November</option>
          <option>December</option>
        </select>
        <select>
          <option>Status</option>
          <option>Paid</option>
          <option>Partial</option>
          <option>Pending</option>
        </select>
        <button className="btn">Apply Filter</button>
        <button className="btn">Reset</button>
      </div>

      {/* Table */}
      <div className="table-container">
        <table className="pamm-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Period</th>
              <th>Total Commission</th>
              <th>Paid Commission</th>
              <th>Pending Commission</th>
              <th>Total Trades</th>
              <th>Total Volume</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {reports.map((report, index) => (
              <tr key={report.id}>
                <td>{index + 1}</td>
                <td>{report.period}</td>
                <td className="amount">{report.totalCommission}</td>
                <td className="success-text">{report.paidCommission}</td>
                <td className={report.pendingCommission !== "$0" ? "warning-text" : ""}>{report.pendingCommission}</td>
                <td>{report.totalTrades}</td>
                <td>{report.totalVolume}</td>
                <td>
                  <span className={`status ${report.status === "Paid" ? "success" : "warning"}`}>
                    {report.status}
                  </span>
                </td>
                <td>
                  <button className="icon-btn" title="View Details">
                    <Eye size={18} />
                  </button>
                  <button className="icon-btn" title="Download Report">
                    <Download size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Footer */}
      <footer className="footer">
        <p>Copyright © 2025 <span className="brand">Vista FX Solutions</span>. All rights reserved.</p>
        <span className="version">Version 2.0</span>
      </footer>
    </div>
  );
}

export default PAMMCommissionReport;
